import React from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import TestimonialSection from "../components/TestimonialSection";
import PagesHero from "../components/PagesHero";
import TermsAndConditionSection from "../components/TermsAndConditionSection";

function TermsAndConditions() {
  return (
    <div>
      <Header />
      <PagesHero page={"Terms and conditions"}/>
      <TermsAndConditionSection />
      <TestimonialSection />
      <FooterSection />
    </div>
  );
}

export default TermsAndConditions;
